module.exports = __webpack_public_path__ + "img/89-fa6871.png";